module.exports = __webpack_public_path__ + "static/media/self-vector.c688975e.png";